import { render, staticRenderFns } from "./notificationDropdown.vue?vue&type=template&id=52dad08d&scoped=true&"
import script from "./notificationDropdown.vue?vue&type=script&lang=js&"
export * from "./notificationDropdown.vue?vue&type=script&lang=js&"
import style0 from "./notificationDropdown.vue?vue&type=style&index=0&id=52dad08d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dad08d",
  null
  
)

export default component.exports